import React from "react";
import useStyles from "./Datepicker.styles";
import clsx from "clsx";
import { List, ListItem, Typography } from "@material-ui/core";
import { DatepickerListItem } from "@mp-react/table";
import Check from "./icons/Check";

interface IProps {
  data: DatepickerListItem[];
  onClick: (value: string, key: string) => void;
  date: string | null;
}

export default function DatepickerItem({ data, onClick, date }: IProps) {
  const classes = useStyles();

  return (
    <List disablePadding>
      {data.map((item) => {
        const isActive = date === item.value;
        return (
          <ListItem
            classes={{
              root: clsx({
                [classes.listItem]: true,
                [classes.noPadding]: !!item?.items,
                [classes.endItem]: !item?.items,
              }),
            }}
            onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
              e.stopPropagation();
              onClick(item.value, item.key);
            }}
            button
            key={item.value}
            disableRipple
          >
            <Typography
              className={clsx({
                [classes.typography]: item?.items,
                [classes.fullWidth]: true,
                [classes.active]: isActive,
              })}
              variant="body2"
            >
              {isActive && <Check className={classes.iconContainer} />}
              {item.label}
            </Typography>
            {item?.items && (
              <DatepickerItem data={item.items} onClick={onClick} date={date} />
            )}
          </ListItem>
        );
      })}
    </List>
  );
}
